/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'

import { BoardItemFragment } from '../../../../../generated/graphql'
import { SecondaryButton } from '../../../../shared/buttons'
import PlaceholderAutoComplete from '../../PlaceholderAutoComplete'

const containerCss = css`
  padding-bottom: 25px;
`

const cancelButtonCss = css`
  float: right;
`

export type PlanItemPlaceholderInputProps = {
  /** Campus used to filter placeholders */
  campus?: string
  /** Current Group Id */
  groupId: string
  /** Event callback when a placeholder is selected */
  onAdd: (planItem: BoardItemFragment) => void
  /** Event callback when the Cancel button is clicked */
  onCancelAdd: () => void
}

const defaultProps: Pick<PlanItemPlaceholderInputProps, 'campus'> = { campus: '' }

export const PlanItemPlaceholderInput = ({
  campus,
  groupId,
  onAdd,
  onCancelAdd
}: PlanItemPlaceholderInputProps) => (
  <div css={containerCss}>
    <PlaceholderAutoComplete campus={campus} groupId={groupId} onChange={onAdd} />
    <SecondaryButton
      ariaLabel="Cancel adding a new placeholder"
      onClick={onCancelAdd}
      css={cancelButtonCss}
    >
      CANCEL
    </SecondaryButton>
  </div>
)

PlanItemPlaceholderInput.defaultProps = defaultProps

export default PlanItemPlaceholderInput
